import { useCallback } from 'react'
import {
  ArrayInput,
  DateInput,
  Edit,
  minValue,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  Toolbar,
  useNotify,
  useRedirect,
  useUpdate,
} from 'react-admin'

import { validateInteger, validateInvoiceItems, validateTwoDecimals } from '../../helpers/validators'
import { SimpleNumberInput } from '../Fields'

const redirect = (data: any) => {
  return `/jobs/${data.job}/show/invoices`
}

const validatePaymentTerms = [validateInteger, required(), minValue(0)]
const validateItemAmounts = [validateTwoDecimals, required()]

const InvoiceEditSaveButton = (props: any) => {
  const [update] = useUpdate('invoices')
  const redirectTo = useRedirect()
  const notify = useNotify()
  const { record, basePath } = props

  const handleSave = useCallback(
    (values, redirect) => {
      update(
        {
          payload: { id: values.id, data: { ...values }, previousData: record },
        },
        {
          onSuccess: ({ data: newRecord }) => {
            notify('Invoice saved', 'info', { smart_count: 1 })
            redirectTo(redirect, basePath, newRecord.job, newRecord)
          },
          onFailure: (error) => {
            notify(`${JSON.stringify(error)}`, { type: 'error' })
          },
        }
      )
    },
    [notify, redirectTo, update, basePath, record]
  )

  return <SaveButton {...props} onSave={handleSave} />
}

const InvoiceEditToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <InvoiceEditSaveButton />
    </Toolbar>
  )
}

const InvoiceEdit = (props: any) => {
  return (
    <Edit undoable={false} {...props}>
      <SimpleForm toolbar={<InvoiceEditToolbar />} redirect={redirect} validate={validateInvoiceItems}>
        <NumberInput source="payment_terms_days" validate={validatePaymentTerms} />
        <DateInput source="date_invoiced" validate={required()} />
        <ArrayInput source="items">
          <SimpleFormIterator>
            <TextInput
              source="description"
              style={{ width: '50%' }}
              label="Description"
              validate={required()}
            />
            <SimpleNumberInput source="amount" label="Amount" validate={validateItemAmounts} />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  )
}

export default InvoiceEdit
